module.exports = __webpack_public_path__ + "img/google.61abacfc.svg";